import { render, staticRenderFns } from "./OtherForm.vue?vue&type=template&id=20835b90&"
import script from "./OtherForm.vue?vue&type=script&lang=js&"
export * from "./OtherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports